import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import SubjectIcon from "@material-ui/icons/Subject";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { Avatar, Button, IconButton, Typography } from "@material-ui/core";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import SystemLabel from "../../../system/SystemLabel/SystemLabel";
import { Row, Col } from "reactstrap";
import ArchiveIcon from "@material-ui/icons/Archive";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import ReplayIcon from "@material-ui/icons/Replay";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";

const wrapperStyle = {
  width: "100%",
  height: "100vh",
  display: "inline-flex",
};
const listCol = {
  width: "20%",
  height: "100%",
  backgroundColor: "#222",
  zIndex: 1,
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0), 0 4px 8px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 20px 20px rgba(0, 0, 0, 0.3) !important",
};
const messageCol = {
  width: "80%",
  height: "100%",
  paddingLeft: "20px",
  backgroundColor: "#1d1d1d",
};
const questionHeaderStyle = {
  padding: "20px",
  boxShadow: "0 1px 2px rgba(0, 0, 0, 0), 0 2px 4px rgba(0, 0, 0, 0), 0 4px 8px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 4px 4px rgba(0, 0, 0, 0), 0 20px 20px rgba(0, 0, 0, 0.3) !important",
  /*     borderBottom: '1px solid gainsboro' */
};
const listStyle = {
  maxHeigth: "100%",
  overflowY: "auto",
  maxHeight: "calc(100vh - 73px)",
  minHeight: "calc(100vh - 73px)",
};

export default class QuetsionAnswerView extends React.Component {
  state = {
    selectedQuestion: null,
    target: null,
    archivedList: [],
    answeredList: [],
    confirmDialog: false,
  };
  renderTypeIcon = (type, active) => {
    switch (type) {
      case "Text":
        return (
          <Avatar style={{ backgroundColor: active ? "rgba(32, 168, 216, 0.88)" : "#56af55" }}>
            <SubjectIcon />
          </Avatar>
        );
      case "Option":
        return (
          <Avatar style={{ backgroundColor: active ? "rgba(32, 168, 216, 0.88)" : "#dc8b4d" }}>
            <CheckBoxIcon />
          </Avatar>
        );
      default:
        break;
    }
  };
  toggleQuestion = (q) => {
    const { selectedQuestion } = this.state;
    if (selectedQuestion && q.questionId === selectedQuestion.questionId) {
      this.setState({ selectedQuestion: null });
    } else {
      this.setState({ selectedQuestion: q });
      this.props.toggleQuestionInfo(q);
    }
  };
  componentDidUpdate(prevProps, prevState) {
    if (this.props.responses.length > prevProps.responses.length) {
      this.handleScroll();
    }
  }
  componentDidMount() {
    this.handleScroll();
  }
  setTarget = (id, type, pre) => {
    this.setState({ target: { id, type }, confirmDialog: true });
  };

  saveStatus = () => {
    if (this.state.target) {
      const { responses, questions } = this.props;
      const { id, type } = this.state.target;
      if (id && type) {
        this.props.setStageStatus(id, type);
      }
    }
    this.setState({ confirmDialog: false });

    //
  };

  handleScroll = (id) => {
    const { responses } = this.props;
    if (responses.length > 0) {
      let index = responses.length - 1;
      if (index > -1 && this.refs[index] !== undefined) {
        try {
          this.refs[index].scrollIntoView({ block: "end", behavior: "smooth" });
        } catch (error) {
          console.error(error);
        }
      }
    }
  };

  render() {
    const { responses, questions, lang, eventName, activeQuestions, connectionList } = this.props;
    const { selectedQuestion } = this.state;
    /*   const resx = responses;
          resx.contat(this.state.customlist) */
    return (
      <div style={wrapperStyle}>
        <div style={listCol} className="stage-list">
          <div style={questionHeaderStyle}>
            <Typography className="primary-text" style={{ fontSize: "1.4rem" }}>
              {" "}
              <SystemLabel name="Questions" languageCode={lang} /> - {eventName}
            </Typography>
            <Typography className="primary-text" style={{ fontSize: "0.8rem" }}>
              {" "}
              <SystemLabel name="ConnectionCount" languageCode={lang} /> {connectionList.length}
            </Typography>
          </div>
          <List style={listStyle} component="nav" className="dark-list" aria-label="main mailbox folders">
            {questions && questions.length > 0
              ? questions
                  .filter((q) => q.type == "Text" && (!q.tag || (q.tag && !q.tag.includes("hideinstage"))))
                  .map((q, i) => {
                    let qLang = q.questionLanguage.find((ql) => ql.languageCode == lang) ?? q.questionLanguage?.[0];
                    let qActive = activeQuestions.some((aq) => aq === q.questionId);
                    return (
                      <React.Fragment key={i}>
                        <ListItem
                          onClick={() => this.toggleQuestion(q)}
                          style={{
                            listStyle: "none",
                            display: "flex",
                          }}
                          ref={i}
                          key={i}
                        >
                          {}
                          <ListItemAvatar>{this.renderTypeIcon(q.type, qActive)}</ListItemAvatar>
                          <ListItemText className="primary-text" style={{ maxWidth: "65%" }} secondary={q.tag} primary={qLang ? qLang.label : "NoLabel"} />
                          <ListItemSecondaryAction>
                            <IconButton style={{ color: "rgba(238, 238, 238, 0.37)" }} onClick={() => this.toggleQuestion(q)}>
                              <ChevronRightIcon />
                            </IconButton>
                          </ListItemSecondaryAction>
                        </ListItem>
                        <Divider variant="inset" component="li" />
                      </React.Fragment>
                    );
                  })
              : null}
          </List>
        </div>
        <div style={messageCol} className="stage-questions">
          <div style={questionHeaderStyle}>
            <Typography className="primary-text" style={{ fontSize: "1.4rem" }}>
              {selectedQuestion ? (
                selectedQuestion.questionLanguage.find((ql) => ql.languageCode == lang)?.label ?? selectedQuestion.questionLanguag?.[0]?.label
              ) : (
                <SystemLabel name="NoQuestionSelected" groupName={"Interaction.Stage"} languageCode={this.props.lang} />
              )}
            </Typography>
          </div>
          <div className="stage-conversation dark-list">
            {selectedQuestion && responses && responses.length > 0
              ? responses
                  .filter((r) => r.questionId == selectedQuestion.questionId && /* ( */ (r.stageStatus == null || r.stageStatus == 1 || r.stageStatus == 0))
                  .map((m, i) => {
                    const name =
                      m.clientKey && m.clientKey.startsWith("sneakyspy") ? (
                        <React.Fragment>
                          <SystemLabel name="Moderator" />
                          {" - "}
                        </React.Fragment>
                      ) : m.clientName.startsWith("Guest_") ? (
                        <React.Fragment>
                          <SystemLabel name="Guest" />
                          {" - "}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {m.clientName}
                          {" - "}
                        </React.Fragment>
                      );
                    return (
                      <div ref={i} key={i} className="c-box">
                        <MessageBox message={m.answer} no={i + 1} timeStamp={m.inserted} lang={this.props.lang} name={name} status={m.stageStatus} setStatus={this.setTarget} id={m.answerId} />
                      </div>
                    );
                  })
              : null}
            {selectedQuestion && responses && responses.length > 0 && responses.filter((r) => r.questionId == selectedQuestion.questionId && r.stageStatus == 2).length > 0 ? (
              <div className="c-box answered" style={{ margin: "40px 0px" }}>
                <hr></hr>
                <div className="hr-header-pill">
                  <CheckCircleOutlineIcon style={{ color: "#fff", marginRight: 5 }} /> {"  "}
                  <SystemLabel name="Answered" languageCode={this.props.lang} />
                </div>
              </div>
            ) : null}
            {selectedQuestion && responses && responses.length > 0
              ? responses
                  .filter((r) => r.questionId == selectedQuestion.questionId && r.stageStatus == 2)
                  .map((m, i) => {
                    const name =
                      m.clientKey && m.clientKey.startsWith("sneakyspy") ? (
                        <React.Fragment>
                          <SystemLabel name="Moderator" />
                          {" - "}
                        </React.Fragment>
                      ) : m.clientName.startsWith("Guest_") ? (
                        <React.Fragment>
                          <SystemLabel name="Guest" />
                          {" - "}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {m.clientName}
                          {" - "}
                        </React.Fragment>
                      );
                    return (
                      <div ref={i} key={i} className="c-box ">
                        <MessageBox message={m.answer} no={i + 1} timeStamp={m.inserted} name={name} lang={this.props.lang} status={m.stageStatus} setStatus={this.setTarget} id={m.answerId} />
                      </div>
                    );
                  })
              : null}
            {selectedQuestion && responses && responses.filter((r) => r.questionId == selectedQuestion.questionId && r.stageStatus == 3).length > 0 ? (
              <div className="c-box archived" style={{ margin: "40px 0px" }}>
                <hr></hr>
                <div className="hr-header-pill">
                  <ArchiveIcon style={{ color: "#fff", marginRight: 5 }} /> {"  "}
                  <SystemLabel name="Archived" languageCode={this.props.lang} />
                </div>
              </div>
            ) : null}
            {selectedQuestion && responses && responses.length > 0
              ? responses
                  .filter((r) => r.questionId == selectedQuestion.questionId && r.stageStatus == 3)
                  .map((m, i) => {
                    const name =
                      m.clientKey && m.clientKey.startsWith("sneakyspy") ? (
                        <React.Fragment>
                          <SystemLabel name="Moderator" />
                          {" - "}
                        </React.Fragment>
                      ) : m.clientName.startsWith("Guest_") ? (
                        <React.Fragment>
                          <SystemLabel name="Guest" />
                          {" - "}
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {m.clientName}
                          {" - "}
                        </React.Fragment>
                      );

                    return (
                      <div ref={i} key={i} className="c-box">
                        <MessageBox message={m.answer} no={i + 1} lang={this.props.lang} timeStamp={m.inserted} name={name} status={m.stageStatus} setStatus={this.setTarget} id={m.answerId} />
                      </div>
                    );
                  })
              : null}
          </div>
        </div>
        {this.state.confirmDialog && this.state.target ? <ConfirmDialog onCancel={() => this.setState({ confirmDialog: false })} onAction={this.saveStatus} lang={this.props.lang} type={this.state.target.type} /> : null}
      </div>
    );
  }
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function ConfirmDialog(props) {
  const getTypLabel = (type) => {
    switch (type) {
      case 1:
        return "Restore";
      case 2:
        return "SetAnwered";
      case 3:
        return "Archive";
      default:
        return "";
    }
  };
  const { onCancel, onAction, type } = props;

  return (
    <div>
      <Dialog open={true} TransitionComponent={Transition} keepMounted onClose={() => null} aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        <DialogTitle id="alert-dialog-slide-title">
          {" "}
          <SystemLabel name="AreYouSure" languageCode={props.lang} />
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <SystemLabel languageCode={props.lang} name={"DoYouWanna" + getTypLabel(type)} />
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={onCancel} color="primary">
            <SystemLabel languageCode={props.lang} name="Close" />
          </Button>
          <Button onClick={onAction} color="primary">
            <SystemLabel languageCode={props.lang} name="Save" />
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

function MessageBox({ message, timeStamp, name, no, status, setStatus, id, lang }) {
  const formatTime = (date) => {
    if (datesAreOnSameDay(new Date(date), new Date())) {
      let formattedDate = new Date(date);
      let h = formattedDate.getHours();
      let m = formattedDate.getMinutes();
      if (m < 10) m = "0" + m;
      if (h < 10) h = "0" + h;
      return h + ":" + m;
    } else {
      let formattedDate = new Date(date);
      let d = formattedDate.getUTCDay().toString().substr(0, 3);
      let h = formattedDate.getHours();
      let m = formattedDate.getMinutes();
      if (m < 10) m = "0" + m;
      if (h < 10) h = "0" + h;
      return (
        <React.Fragment>
          {dayConverter(d)} {h + ":" + m}
        </React.Fragment>
      );
    }
  };
  const dayConverter = (d, h, m) => {
    switch (d) {
      case "1":
        return <SystemLabel languageCode={lang} name="Monday" />;
      case "2":
        return <SystemLabel languageCode={lang} name="Tuesday" />;
      case "3":
        return <SystemLabel languageCode={lang} name="Wednesday" />;
      case "4":
        return <SystemLabel languageCode={lang} name="Thursday" />;
      case "5":
        return <SystemLabel languageCode={lang} name="Friday" />;
      case "6":
        return <SystemLabel languageCode={lang} name="Saturday" />;
      case "7":
        return <SystemLabel languageCode={lang} name="Sunday" />;
      default:
        return "";
    }
  };
  const datesAreOnSameDay = (first, second) => first.getFullYear() === second.getFullYear() && first.getMonth() === second.getMonth() && first.getDate() === second.getDate();
  return (
    <div style={{ width: "100%" }}>
      <Row style={{ width: "100%" }}>
        <Col className={"stage-messages stage-messages--received"}>
          <div className={"stage-time-stamp"}>
            <strong
              style={{
                marginRight: 15,
                color: "#fff",
              }}
            >
              {" "}
              #{no}{" "}
            </strong>{" "}
            {name} {formatTime(timeStamp)}
          </div>
        </Col>
      </Row>
      <Row style={{ width: "100%" }}>
        <Col className={"col-8 stage-messages stage-messages--received"}>
          <div className={"stage-message"}>{message}</div>
        </Col>
        <Col className="col-4 text-left" style={{ padding: 0 }}>
          <div className="stage-wrap">
            {status != 2 || status == 1 || status == 0 || !status ? (
              <div onClick={() => setStatus(id, 2, status)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <CheckCircleOutlineIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name="SetAnswered" languageCode={lang} />
                </div>
              </div>
            ) : null}
            {(status == 2 || status == 1 || !status) && status != 3 ? (
              <div onClick={() => setStatus(id, 3, status)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <ArchiveIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name="Archive" languageCode={lang} />
                </div>
              </div>
            ) : null}
            {status == 2 || status == 3 ? (
              <div onClick={() => setStatus(id, 1, status)} className="stage-tools">
                <div style={{ width: "100%" }}>
                  <ReplayIcon />
                </div>
                <div style={{ width: "100%" }}>
                  <SystemLabel name="Restore" languageCode={lang} />
                </div>
              </div>
            ) : null}
          </div>
        </Col>
      </Row>
    </div>
  );
}
